module.exports = __webpack_public_path__ + "static/media/pic48.15dfa89f.jpg";